import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Paper from 'material-ui/Paper';
import Snackbar from 'material-ui/Snackbar';
import { InfoStringForm } from './InfoStringForm';
import environment from '../../lib/RelayUtils';
import * as InfoStringEditMutation from '../../mutations/InfoStringEditMutation';
import * as InfoStringDeleteMutation from '../../mutations/InfoStringDeleteMutation';
import { createFragmentContainer, graphql } from 'react-relay';
import RaisedButton from 'material-ui/RaisedButton';

const bodyStyle = { backgroundColor: '#ef426f', height: 'auto', lineHeight: '16px', padding: 12, whiteSpace: 'pre-line' };

const InfoStringEdit = props => {
	const { history, viewer } = props;
	const [snackbarMessage, setSnackbarMessage] = useState(undefined);

	const initialValues = viewer.infoString;

	const onSubmit = data => {
		const request = {
			...data,
			id: viewer.infoString.id,
		};
		InfoStringEditMutation.commit(environment, request, (error: ?Error) => {
			if (error) {
				setSnackbarMessage('Ошибка во время сохранения');
			} else {
				setSnackbarMessage('Запись успешно создан');
				history.push('/info-strings');
			}
		});
	};

	const handleCloseSnackbar = () => setSnackbarMessage(undefined);

	const handleDelete = () => {
		if (confirm('Вы действитель хотите удалить бегущую строку?')) {
			InfoStringDeleteMutation.commit(
				environment,
				{
					id: viewer.infoString.id,
				},
				(error: ?Error) => {
					if (!error) {
						history.push('/info-strings');
					}
				},
			);
		}
	};

	if (!viewer.infoString) {
		return <Paper style={{ width: '100%', padding: 16 }}>Передан неверный идентификатор</Paper>;
	}

	return (
		<Paper style={{ width: '100%', padding: 16 }}>
			<InfoStringForm initialValues={initialValues} viewer={props.viewer} isCreation={true} onSubmit={onSubmit}>
				<RaisedButton
					style={{
						marginLeft: 20,
					}}
					labelColor={'#ffffff'}
					onClick={handleDelete}
					backgroundColor={'#f50000'}
					label={'Удалить'}
				/>
			</InfoStringForm>
			{snackbarMessage && <Snackbar open={true} bodyStyle={bodyStyle} message={snackbarMessage} onRequestClose={handleCloseSnackbar} />}
		</Paper>
	);
};

export default withRouter(
	createFragmentContainer(
		InfoStringEdit,
		graphql`
			fragment InfoStringEdit_viewer on Viewer @argumentDefinitions(id: { type: "ID!" }) {
				id
				infoString(id: $id) {
					...InfoStringListItem_item @relay(mask: false)
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/info-strings/InfoStringEdit.js